import { useSettings } from 'connectors/Settings/Settings';
import twMerge from 'utils/twMerge';

export const HomepageTextBlock: FC = ({ className }) => {
    const settings = useSettings();

    if (!settings?.homepageTextBlock) {
        return null;
    }

    return (
        <div
            className={twMerge('w-full pb-2', className)}
            dangerouslySetInnerHTML={{
                __html: settings.homepageTextBlock,
            }}
        />
    );
};
